import { render, staticRenderFns } from "./createTask.vue?vue&type=template&id=3d2b7ff4&scoped=true&"
import script from "./createTask.vue?vue&type=script&lang=js&"
export * from "./createTask.vue?vue&type=script&lang=js&"
import style0 from "./createTask.vue?vue&type=style&index=0&id=3d2b7ff4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2b7ff4",
  null
  
)

component.options.__file = "createTask.vue"
export default component.exports